import { gsap } from "gsap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { getViewport } from "../helpers";

export default class Drawer extends HTMLElement {

	constructor() {

		super();

		this.trigger = this.dataset.trigger && document.getElementById(this.dataset.trigger)
		this.triggerArray = this.dataset.triggerArray && document.querySelectorAll(this.dataset.triggerArray);

		this.externalContent = this.dataset.external === 'true' ? true : false
		this.externalContentContainer = this.externalContent && this.querySelector('.pdp-content')
		this.drawer = this.querySelector(".drawer")
		this.closeBtn = this.querySelector(".close-drawer")
		this.backdrop = this.querySelector(".backdrop")
		this.scrolling = this.dataset.scrolling == "" ? this.drawer : this.querySelector(this.dataset.scrolling);

		this.isOpen = false;

		this.interactive = [...this.querySelectorAll('a, button, [tabindex]')]; // a11y
		this.focusReturn = this.trigger; // a11y

		if (this.trigger && this.trigger.closest("form")) {
			this.mutationObserver = new MutationObserver(this.mutationCallback.bind(this));
			this.mutationObserver.observe(this.trigger.closest("form"), { childList: true });
		}

		this.bindMethods();
		this.init();
	}

	bindMethods() {
		['drawerOpen', 'drawerClose', 'handleKeyClose', 'handleOpenComplete', 'handleCloseComplete']
			.forEach(fn => this[fn] = this[fn].bind(this));
	}

	bindCloseTrigger() {
		this.backdrop.addEventListener('click', this.drawerClose)
		this.closeBtn?.addEventListener('click', this.drawerClose)
		document.addEventListener('keyup', this.handleKeyClose);
	}

	handleKeyClose(event) {
		let key = event.key;
		if (key === 'Escape' || key === 'Esc') {
			this.drawerClose();
		}
	}

	bindOpenTrigger() {
		if (this.trigger) {
			this.trigger.addEventListener('click', this.drawerOpen)
		} else if (this.triggerArray) {
			this.triggerArray.forEach(btn => {
				btn.addEventListener('click', (e) => {
					this.drawerOpen({ url: e.target.dataset.href })
				})
			})
		}
	}

	bindFirstAndLast() {

		let first, last;
		if (this.interactive.length > 1) {
			first = this.interactive[0];
			last = this.interactive[this.interactive.length - 1];
		} else if (this.interactive.length == 1) {
			first = this.interactive[0];
			last = this.interactive[0];
		} else {
			return;
		}

		first.addEventListener("keydown", (event) => {
			if (event.shiftKey && event.key === 'Tab') {
				//shift was down when tab was pressed
				event.preventDefault();
				// move focus back to trigger and close menu
				this.drawerClose();
			}
		});

		last.addEventListener("keydown", (event) => {
			if (!event.shiftKey && event.key === 'Tab') {
				//tab was pressed without shift
				event.preventDefault();
				// move focus back to trigger and close menu
				this.drawerClose();
			}
		});

	}

	drawerOpen({ url } = {}) {
		if (this.isOpen) {
			return;
		}


		if (url) this.fetchSectionContent(url)

		this.isOpen = true;
		if (getViewport().width > 768) {
			disableBodyScroll(this.scrolling, { reserveScrollBarGap: true });
		}

		this.backdrop.style.pointerEvents = "all";
		gsap.to(this.backdrop, { opacity: 0.5, duration: 0.3 });

		if (getViewport().width > 768) {
			gsap.to(this.drawer, { x: 0, duration: 0.3, onComplete: this.handleOpenComplete });
		} else {
			gsap.to(this.drawer, { y: 0, duration: 0.3, onComplete: this.handleOpenComplete });
		}

		// if (document.querySelector("build-a-box").focusTrap) {
		// 	document.querySelector("build-a-box").focusTrap.pause();
		// }
	}

	drawerClose() {
		if (!this.isOpen) {
			return;
		}
		this.isOpen = false;
		if (getViewport().width > 768) {
			enableBodyScroll(this.scrolling)
		}
		this.backdrop.style.pointerEvents = "none";
		gsap.to(this.backdrop, { opacity: 0, duration: 0.3 });
		if (getViewport().width > 768) {
			gsap.to(this.drawer, { x: "100%", duration: 0.3, onComplete: this.handleCloseComplete });
		} else {
			gsap.to(this.drawer, { y: "100%", duration: 0.3, onComplete: this.handleCloseComplete });
		}
		// if (document.querySelector('build-a-box').focusTrap) {
		// 	document.querySelector("build-a-box").focusTrap.unpause();
		// }
	}

	fetchSectionContent(url) {
		fetch(`${window.Shopify.routes.root}products/${url}`)
			.then((response) => {

				if (!response.ok) {

					let error = new Error(response.status);

					throw error;
				}

				return response.text();
			})
			.then((text) => {

				let dom = new DOMParser().parseFromString(text, "text/html");
				let markup = dom.querySelector(`section.product-hero`).innerHTML;

				this.externalContentContainer.innerHTML = markup;

				window.Zero.lazyLoad.update();
			})
			.catch((error) => {

				throw error;
			});
	}

	handleOpenComplete() {
		if (this.interactive) {
			this.interactive[0].focus();
		}
	}

	handleCloseComplete() {
		if (this.focusReturn) {
			this.focusReturn.focus();
		}
	}

	rebind() {
		this.trigger = document.getElementById(this.dataset.trigger)
		this.trigger.addEventListener("click", this.drawerOpen.bind(this));
	}

	mutationCallback(mutations) {
		this.rebind();
	}

	init() {
		this.bindOpenTrigger();
		this.bindCloseTrigger();
		this.bindFirstAndLast();
	}

}
